import { AssetDTO } from "src/app/shared/models/models";


export class PublicDetails {
  pageTitle:string = '';
  economicCapsulesSectionTitle :string = '';
  economicCapsulesSectionIcon: AssetDTO= new AssetDTO();
  aboutEconomicCapsules:string = '';
  economicResearchesSectionTitle:string = '';
  economicResearchesSectionIcon: AssetDTO= new AssetDTO();
  aboutEconomicResearches:string = '';
  economicIndicatorsSectionTitle:string = '';
  economicIndicatorsSectionIcon: AssetDTO= new AssetDTO();
  aboutEconomicIndicators:string = '';
  economicCountryReportsSectionTitle:string = '';
  economicCountryReportsSectionIcon: AssetDTO= new AssetDTO();
  aboutEconomicCountryReports:string = '';
  hideEconomicCapsulesSection:string = '';
  hideEconomicResearchesSection:string = '';
  hideEconomicIndicatorsSection:string = '';
}

export class PublicModel {
  flatData: PublicDetails = new PublicDetails();
}